import { Component, Output, EventEmitter, forwardRef, ViewChild } from '@angular/core';
import { NgModelGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Poll } from './Poll';
import { POLL_ANSWERS_MAX } from './Polls';
import { EditWebcastBaseSettingsComponent } from '../editWebcast/EditWebcastBaseSettings.Component';

import 'rev-less/events/vb-webcast-poll-input.less';
@Component({
	selector: 'poll-input',
	templateUrl: './PollInput.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => PollInputComponent),
		multi: true
	}, {
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => PollInputComponent),
		multi: true,
	}],
	standalone: false
})
export class PollInputComponent extends EditWebcastBaseSettingsComponent {
	@Output() public onRemovePoll: EventEmitter<any> = new EventEmitter();
	public readonly maxAnswerCount = POLL_ANSWERS_MAX;

	@ViewChild(NgModelGroup)
	public ansGroup: NgModelGroup;

	public poll: Poll;

	private onChangeFn: (val: Poll) => void;
	private onTouchFn: () => void;

	public writeValue(val: Poll): void {
		this.poll = val;
	}

	public registerOnChange(fn: any): void {
		this.onChangeFn = fn;
	}

	public registerOnTouched(fn: any): void {
		this.onTouchFn = fn;
	}

	public addAnswer(index: number): void {
		if (this.poll.answers.length < this.maxAnswerCount) {
			this.poll.answers.push({ text: '' });
		}
	}

	public isFirstAnswerRequired(): boolean {
		//first answer input is only marked required if all answers are empty
		return this.poll.answers.every(answer => !answer.text);
	}

	public onQuestionChange(): void {
		this.form.control.get('ansGroup').markAsTouched();
	}

}
